export default __webpack_public_path__ + "static/media/Neophyte's Leggings of the Dark Pact.acb3f606.jpg";